// removed by extract-text-webpack-plugin
module.exports = {"Bubble":"t_JBv70okpX22JQbIG_cT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Tooltip/index.css
// module id = 1484
// module chunks = 1